export default function CategoryGridSkeleton({ count = 8 }: { count?: number }) {
  return (
    <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className="animate-pulse overflow-hidden rounded-lg border border-background-200/70 bg-background-50"
        >
          <div className="aspect-square w-full bg-background-100" />
          <div className="space-y-3 p-4">
            <div className="h-4 w-3/4 rounded bg-background-200" />
            <div className="h-5 w-1/3 rounded bg-background-200" />
            <div className="h-3 w-1/2 rounded bg-background-100" />
          </div>
        </div>
      ))}
    </div>
  );
}